(function () {
  var GIFT_HANDLES = ['wooden-comb', 'scalp-messager'];

  var BUNDLE_HANDLES = [
    'scalp-hair-repair-duo',
    'dry-damaged-hair-repair-family-pack',
    '21-day-hair-fall-control-challenge',
    'hair-fall-control-and-repair-kit',
    'frizz-control-smooth-hair-kit',
    'complete-hair-restoration-kit',
    'hair-fall-control-duo',
    'instant-smooth-shine-kit',
    'hair-fall-control-and-frizz-free-shine-kit',
    'scalp-defense-shampoo-for-oily-scalp',
    'summer-fresh-duo' 
  ];

  // ==================================================================
  // UPDATED — the "Create Your Own Bundle" items are now all VARIANTS
  // of one single product (handle below), not separate products. So
  // "2+ distinct items" now means 2+ distinct VARIANT IDs of that one
  // product, not 2+ distinct handles. If you ever go back to separate
  // products for this, swap this back to a handle-list + handle-count
  // check like before.
  // ==================================================================
  var BYO_BUNDLE_PRODUCT_HANDLE = 'create-bundle';

  function hasQualifyingBundle(cart) {
    var hasFixedBundle = cart.items.some(function (item) {
      return BUNDLE_HANDLES.indexOf(item.handle) > -1;
    });
    if (hasFixedBundle) return true;

    var distinctByoVariants = {};
    cart.items.forEach(function (item) {
      if (item.quantity > 0 && item.handle === BYO_BUNDLE_PRODUCT_HANDLE) {
        distinctByoVariants[item.variant_id] = true;
      }
    });
    return Object.keys(distinctByoVariants).length >= 2;
  }

  var isFixingBundle = false; // guards the reload-based bundle-removal fix
  var isFixingQty = false;    // guards the silent, no-reload quantity fix

  function showMessage(text) {
    var existing = document.getElementById('gift-limit-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'gift-limit-toast';
    toast.textContent = text;
    toast.style.position = 'fixed';
    toast.style.top = '16px';
    toast.style.left = '50%';
    toast.style.transform = 'translateX(-50%)';
    toast.style.background = '#222';
    toast.style.color = '#fff';
    toast.style.padding = '12px 22px';
    toast.style.borderRadius = '6px';
    toast.style.fontSize = '14px';
    toast.style.fontFamily = 'sans-serif';
    toast.style.zIndex = '2147483647';
    toast.style.boxShadow = '0 2px 10px rgba(0,0,0,0.3)';
    toast.style.transition = 'opacity 0.4s ease';
    toast.style.opacity = '1';
    document.body.appendChild(toast);

    setTimeout(function () {
      toast.style.opacity = '0';
      setTimeout(function () { toast.remove(); }, 400);
    }, 3000);
  }

  function getCart(cb) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(cb).catch(function () {});
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
  }

  function enforceCartRules() {
    getCart(function (cart) {
      var hasBundle = hasQualifyingBundle(cart);

      var giftIndex = -1;
      var giftItem = null;
      cart.items.forEach(function (item, i) {
        if (giftIndex === -1 && GIFT_HANDLES.indexOf(item.handle) > -1) {
          giftIndex = i + 1;
          giftItem = item;
        }
      });

      if (giftIndex === -1) return;

      // Rule 1: bundle removed, gift kept -> remove gift + reload (needs to be visibly correct)
      if (!hasBundle) {
        if (isFixingBundle) return;
        isFixingBundle = true;
        changeLine(giftIndex, 0).then(function () { location.reload(); });
        return;
      }

      // Rule 2: gift quantity above 1 -> silently correct on the server, no reload
      if (giftItem.quantity > 1 && !isFixingQty) {
        isFixingQty = true;
        showMessage('You can only avail 1 Free Gift');
        changeLine(giftIndex, 1).then(function () {
          isFixingQty = false;
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', enforceCartRules);

  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    return origFetch.apply(this, args).then(function (response) {
      try {
        var url = (args[0] && args[0].url) || args[0];
        if (typeof url === 'string' && url.indexOf('/cart/') > -1) {
          setTimeout(enforceCartRules, 500);
        }
      } catch (e) {}
      return response;
    });
  };

  if (window.location.pathname.indexOf('/cart') > -1) {
    setInterval(enforceCartRules, 2000);
  }

  // ==================================================================
  // EXTRA LAYER: guard the Checkout button click itself.
  // Everything above this line is unchanged from before. This adds
  // an immediate check the moment Checkout is clicked, so there's no
  // gap between "something's wrong with the cart" and "the interval
  // or reload catches up" — it validates right at the click.
  // ==================================================================
  var CHECKOUT_SELECTOR = 'a[href*="/checkout"], button[name="checkout"], input[name="checkout"]';

  function guardCheckoutClick(e) {
    var el = e.target.closest(CHECKOUT_SELECTOR);
    if (!el) return;

    e.preventDefault();
    e.stopPropagation();

    getCart(function (cart) {
      var hasBundle = hasQualifyingBundle(cart);

      var giftIndex = -1;
      var giftItem = null;
      cart.items.forEach(function (item, i) {
        if (giftIndex === -1 && GIFT_HANDLES.indexOf(item.handle) > -1) {
          giftIndex = i + 1;
          giftItem = item;
        }
      });

      // No gift in cart at all — nothing to guard, proceed normally
      if (giftIndex === -1) {
        window.location.href = '/checkout';
        return;
      }

      // Same Rule 1 check, but blocks navigation instead of just reloading
      if (!hasBundle) {
        showMessage('Free gift requires a qualifying bundle, or 2+ products, in your cart.');
        changeLine(giftIndex, 0).then(function () { location.reload(); });
        return;
      }

      // Same Rule 2 check, but blocks navigation instead of letting it through
      if (giftItem.quantity > 1) {
        showMessage('You can only avail 1 Free Gift');
        changeLine(giftIndex, 1); // corrects it; customer can click Checkout again
        return;
      }

      // Cart is valid — let checkout proceed
      window.location.href = '/checkout';
    });
  }

  document.addEventListener('click', guardCheckoutClick, true);
})();